<template>
  <div style="position: relative">
    <component :is="getComponentName" :payload="getCurrentStep.payload"></component>
    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Loader from '../../Loader'
  import ProfileList from './ProfileList'
  import ProfileEdit from './ProfileEdit'
  import ProfileCreate from './ProfileCreate'
  import ProfileTypeChoose from './ProfileTypeChoose'

  export default {
    name: 'profiles',
    components: {
      Loader,
      ProfileList,
      ProfileEdit,
      ProfileTypeChoose,
      ProfileCreate
    },
    computed: {
      ...mapGetters('profile', [
        'loading',
        'getCurrentStep'
      ]),
      getComponentName: function () {
        switch (this.getCurrentStep.code) {
          case 'list':
            return 'ProfileList'
          case 'edit':
            return 'ProfileEdit'
          case 'create':
            return 'ProfileCreate'
          case 'chooseType':
            return 'ProfileTypeChoose'
          default:
            return null
        }
      }
    }
  }
</script>

<style
  lang="scss"
  scoped>
  .tab-content {
    margin-top: 20px;
  }

  .form {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/Profiles.vue